const macModifierMap = {
  mod: '⌘',
  meta: '⌘',
  command: '⌘',
  shift: '⇧',
  control: 'Ctrl',
  ctrl: 'Ctrl',
  option: 'Option',
  alt: 'Option',
  altgr: 'Option',
  fn: 'Fn',
};

const windowsModifierMap = {
  mod: 'Ctrl',
  meta: 'Win',
  command: 'Win',
  shift: 'Shift',
  control: 'Ctrl',
  ctrl: 'Ctrl',
  option: 'Alt',
  alt: 'Alt',
  altgr: 'AltGr',
  fn: 'Fn',
};

const macSpecialKeysMap = {
  enter: '↩',
  return: '↩',
  tab: '⇥',
  escape: '⎋',
  esc: '⎋',
  space: '␣',
  backspace: '⌫',
  delete: '⌦',
  home: '↖',
  end: '↘',
  pageup: '⇞',
  pagedown: '⇟',
};

const windowsSpecialKeysMap = {
  enter: 'Enter',
  return: 'Enter',
  tab: 'Tab',
  escape: 'Esc',
  esc: 'Esc',
  space: 'Space',
  backspace: 'Backspace',
  delete: 'Del',
  home: 'Home',
  end: 'End',
  pageup: 'PgUp',
  pagedown: 'PgDn',
};

const commonKeyMap = {
  arrowup: '↑',
  arrowdown: '↓',
  arrowleft: '←',
  arrowright: '→',

  f1: 'F1',
  f2: 'F2',
  f3: 'F3',
  f4: 'F4',
  f5: 'F5',
  f6: 'F6',
  f7: 'F7',
  f8: 'F8',
  f9: 'F9',
  f10: 'F10',
  f11: 'F11',
  f12: 'F12',

  comma: ',',
  period: '.',
  semicolon: ';',
  quote: "'",
  backquote: '`',
  bracketleft: '[',
  bracketright: ']',
  backslash: '\\',
  slash: '/',
  minus: '-',
  equal: '=',

  numpad0: '0',
  numpad1: '1',
  numpad2: '2',
  numpad3: '3',
  numpad4: '4',
  numpad5: '5',
  numpad6: '6',
  numpad7: '7',
  numpad8: '8',
  numpad9: '9',

  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  numpadadd: '+',
  numpadsubtract: '-',
  numpadmultiply: '*',
  numpaddivide: '/',
  numpaddecimal: '.',

  audiolowervolume: '🔉',
  audioraisevolume: '🔊',
  audiomute: '🔇',
  audiovolumemute: '🔇',
  medianexttrack: '⏭',
  mediaplaypause: '⏯',
  mediaprevioustrack: '⏮',
  mediastop: '⏹',

  a: 'A',
  b: 'B',
  c: 'C',
  d: 'D',
  e: 'E',
  f: 'F',
  g: 'G',
  h: 'H',
  i: 'I',
  j: 'J',
  k: 'K',
  l: 'L',
  m: 'M',
  n: 'N',
  o: 'O',
  p: 'P',
  q: 'Q',
  r: 'R',
  s: 'S',
  t: 'T',
  u: 'U',
  v: 'V',
  w: 'W',
  x: 'X',
  y: 'Y',
  z: 'Z',
};

const macKeyMap = { ...macModifierMap, ...macSpecialKeysMap, ...commonKeyMap };
const windowsKeyMap = {
  ...windowsModifierMap,
  ...windowsSpecialKeysMap,
  ...commonKeyMap,
};

export type KeyName = keyof typeof macKeyMap;

export function isMacPlatform(): boolean {
  if (typeof window !== 'undefined' && window.systemInfo?.platform) {
    return window.systemInfo.platform === 'darwin';
  }
  return typeof navigator !== 'undefined' && navigator.platform.includes('Mac');
}

export function fmtKeyToSymbol(key: KeyName): string {
  const map = isMacPlatform() ? macKeyMap : windowsKeyMap;
  if (key in map) {
    return map[key];
  } else if (key.length === 1) {
    return key.toUpperCase();
  } else {
    return key;
  }
}
